import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import ChatMessageViewState, { ChatMessageType } from '../store/schema/ChatMessageViewState';
import loc, { format } from 'owa-localize';
import * as trace from 'owa-trace';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import {
    ucmaParticipantJoin,
    ucmaParticipantLeave,
    ucmaDeliveryError,
    ucmaDeliveryTimeout,
} from '../strings.locstring.json';

import styles from './ChatMessageNotice.scss';

export interface ChatMessageProps {
    chatMessage: ChatMessageViewState;
}

export default observer(function ChatMessageNotice(props: ChatMessageProps) {
    const { chatMessage } = props;
    const { fromSipUri } = chatMessage;
    const displayName = getRecipientDisplayName(fromSipUri);

    let message = undefined;
    let errorType = false;

    switch (chatMessage.messageType) {
        case ChatMessageType.ParticipantJoin:
            message = format(loc(ucmaParticipantJoin), displayName);
            break;
        case ChatMessageType.ParticipantLeave:
            message = format(loc(ucmaParticipantLeave), displayName);
            break;
        case ChatMessageType.FailedDelivery:
            message = loc(ucmaDeliveryError);
            errorType = true;
            break;
        case ChatMessageType.DeliveryTimeout:
            message = loc(ucmaDeliveryTimeout);
            errorType = true;
            break;
        case ChatMessageType.InstantMessage:
        case ChatMessageType.InstantMessageFromToast:
            trace.errorThatWillCauseAlert('unexpected message type for chat message notice');
            break;
    }

    return message ? (
        <div className={errorType ? styles.errorMessage : styles.systemMessage}>
            <span>{message}</span>
        </div>
    ) : null;
});
